import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";
import { actions as formActions } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { useProjekt } from "b2b/api/hooks";
import { ADMIN } from "b2b/api/paths";
import { useRedirect } from "b2b/hooks";
import { PATHS } from "b2b/constants";

import useMessages from "./i18n/useMessages";

export const FORM_MODULE_KEY = "projektVytvoreni";

export default function useProjektVytvoreni({ zakaznik }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const loader = useProjekt({ id });
  const redirect = useRedirect();
  const { saveDialogTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const redirectToZakaznik = useCallback(() => {
    redirect(
      PATHS.ADMINISTRACE.ZAKAZNIK,
      {
        ico: zakaznik.ico
      },
      { state: { openGrid: "projekty" } }
    );
  }, [redirect, zakaznik]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    redirectToZakaznik();
  }, [hideDialog, redirectToZakaznik]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.projekt(values.id),
        method: id ? "put" : "post",
        payload: values,
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [zakaznik, showDialog, handleSuccess]
  );

  useEffect(() => {
    loader.data &&
      dispatchModuleAction(
        dispatch,
        FORM_MODULE_KEY,
        formActions.setValues(loader.data)
      );
  }, [loader.data]);

  return {
    formModuleKey: FORM_MODULE_KEY,
    isEdit: !!id,
    loader,
    onSubmit: handleSubmit,
    onCancel: redirectToZakaznik
  };
}
